import PropTypes from "prop-types";
import Creature from "./Creature";
import Leaderboard from "./Leaderboard";
import usePointer from "./usePointer";

const STEPS = [
  { place: 1, height: "h-40", label: "1st" },
  { place: 2, height: "h-28", label: "2nd" },
  { place: 3, height: "h-20", label: "3rd" },
];
// Second on the left, first in the middle, third on the right.
const ORDER = [1, 0, 2];

/** The final screen: the top three on steps, everyone else below. */
function Podium({ rows }) {
  const look = usePointer();
  const top = rows.slice(0, 3);
  const rest = rows.slice(3);
  return (
    <div className="space-y-8">
      <ol className="flex items-end justify-center gap-4" aria-label="Podium">
        {ORDER.filter((i) => top[i]).map((i) => {
          const row = top[i];
          const step = STEPS[i];
          return (
            <li key={row.nickname} className="flex w-44 flex-col items-center">
              <Creature kind={row.creature} size={i === 0 ? 140 : 110} look={look} mood={i === 0 ? "happy" : "idle"} />
              <span className="mt-1 max-w-full truncate text-2xl font-semibold">{row.nickname}</span>{" "}
              <span className="text-lg tabular-nums text-muted-foreground">{row.score} points</span>{" "}
              <div
                className={`mt-2 flex w-full items-start justify-center rounded-t-lg border bg-muted pt-2 font-display text-3xl font-semibold ${step.height}`}
              >
                {step.label}
              </div>
            </li>
          );
        })}
      </ol>
      {rest.length > 0 && (
        <div className="mx-auto max-w-xl">
          <Leaderboard rows={rest} />
        </div>
      )}
    </div>
  );
}

Podium.propTypes = {
  rows: PropTypes.arrayOf(
    PropTypes.shape({
      rank: PropTypes.number.isRequired,
      nickname: PropTypes.string.isRequired,
      creature: PropTypes.number.isRequired,
      score: PropTypes.number.isRequired,
    }),
  ).isRequired,
};

export default Podium;
